<template>
  <div class="default-wrapper">
    <my-header />
    <div v-bind:class="{ 'container-fluid': isMPRoute }">
      <div v-bind:class="{ row: isMPRoute }">
        <div class="sidebar-wrapper" v-bind:class="{ closed: isClosed }" v-if="!isPublicRoute">
          <!-- <sidebar v-if="getAuthUser()" /> -->
        </div>
        <div
          v-bind:class="{
            closed: isClosed,
            'main-content': !isPublicRoute,
            col: isMPRoute,
          }"
        >
          <b-overlay :show="this.$store.getters.contentLoading" rounded="sm">
            <template #overlay>
              <div class="text-center">
                <b-spinner></b-spinner>
                <p>
                  <small>{{ $t(LangConstants.loading_text) }} </small>
                </p>
              </div>
            </template>
            <router-view />
          </b-overlay>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MyHeader from "../components/organisms/Header.vue";
//import Sidebar from "../components/organisms/Sidebar.vue";
import Common from "../functions/index";
import Constants from "../constants/index";
import i18n from "../i18n";
import "../assets/scss/common.scss";
export default {
  name: "App",
  data() {
    return {
      loading: true,
      isClosed: false,
    };
  },
  beforeMount() {
    //    var ddd = {
    //    "Hello Welcome to Sparkfore": "Hello Welcome to Sparkfore",
    // "Total": "Total",
    // "Discount Code Status": "Discount Code Status",
    // "Creation Discount Code was a success": "Creation Discount Code was a success",
    // "Creation Discount Code was a failure": "Creation Discount Code was a failure",
    // "Create Account": "Create Account",
    // "Select Subdomain": "Select Subdomain",
    // "Payment Method": "Payment Method",
    // "Your Order": "Your Order",
    // "Create or Sign-In": "Create or Sign-In",
    // "Profile": "Profile",
    // "Log Out": "Log Out",
    // "Switch role to...": "Switch role to...",
    // "General Information": "General Information",
    // "Information not available": "Information not available",
    // "Secure transaction": "Secure transaction",
    // "Sold through": "Sold through",
    // "Autotech Development": "Autotech Development",
    // "Provided by": "Provided by",
    // "Return policy": "Return policy",
    // "Not eligible for return, refund or replacement": "Not eligible for return, refund or replacement",
    // "Support": "Support",
    // "Free Sparkfore support plan included": "Free Sparkfore support plan included",
    // "Licenses available : 365 days": "Licenses available : 365 days",
    // "Type": "Type",
    // "Languages": "Languages",
    // "Length": "Length",
    // "Shop": "Shop",
    // "Shop Item": "Shop Item",
    // "Currently You do not have any courses in your shop.": "Currently You do not have any courses in your shop.",
    // "Users": "Users",
    // "Groups": "Groups",
    // "Courses": "Courses",
    // "Reports": "Reports",
    // "Company Account": "Company Account",
    // "Company Profile": "Company Profile",
    // "Signup Forms": "Signup Forms",
    // "Webshop": "Webshop",
    // "Control Panel": "Control Panel",
    // "Dashboard": "Dashboard",
    // "Customer Settings": "Customer Settings",
    // "General Settings": "General Settings",
    // "Company Name": "Company Name",
    // "Our Account Manager": "Our Account Manager",
    // "Customer Team Lead Account": "Customer Team Lead Account",
    // "Courses to get enrolled in after signup": "Courses to get enrolled in after signup",
    // "Select Courses": "Select Courses",
    // "Add this course": "Add this course",
    // "Limit registration to domains": "Limit registration to domains",
    // "Type new domain": "Type new domain",
    // "Maximum allowed registrations": "Maximum allowed registrations",
    // "Proceed to Create Form": "Proceed to Create Form",
    // "Custom Title": "Custom Title",
    // "Enter Your Title": "Enter Your Title",
    // "Custom Description": "Custom Description",
    // "Enter Your Description Here": "Enter Your Description Here",
    // "Choose a file or drop it here...": "Choose a file or drop it here...",
    // "Drop file here...": "Drop file here...",
    // "Add Other Fields": "Add Other Fields",
    // "Delete Fields": "Delete Fields",
    // "Delete Field": "Delete Field",
    // "Captcha": "Captcha",
    // "Proceed to Generate Sharing Link": "Proceed to Generate Sharing Link",
    // "To share the Signup Form, please share the link generated below:": "To share the Signup Form, please share the link generated below:",
    // "Generated Link": "Generated Link",
    // "Generated URL": "Generated URL",
    // "Copy URL Address": "Copy URL Address",
    // "Back to Overview": "Back to Overview",
    // "Link Copied to Clipboard": "Link Copied to Clipboard",
    // "Information": "Information",
    // "Approximate time": "Approximate time",
    // "English (US)": "English (US)",
    // "Your browser doesn't support a stable version of IndexedDB.": "Your browser doesn't support a stable version of IndexedDB.",
    // "Unable to add data": "Unable to add data",
    // "Cannot open the database after 5 retries": "Cannot open the database after 5 retries",
    // "Monthly": "Monthly",
    // "Annually": "Annually",
    // "Quarterly": "Quarterly",
    // "Custom Sign-Up Page": "Custom Sign-Up Page",
    // "Share Link": "Share Link",
    // "E-learning": "E-learning",
    // "Blended": "Blended",
    // "Instructor-led": "Instructor-led",
    // "Mobile Phone": "Mobile Phone",
    // "Enter the mobile phone": "Enter the mobile phone",
    // "Home Phone": "Home Phone",
    // "Enter the Home Phone Number": "Enter the Home Phone Number",
    // "Organization Affiliation": "Organization Affiliation",
    // "Enter Company Name": "Enter Company Name",
    // "Address": "Address",
    // "Enter Company Address": "Enter Company Address",
    // "Zip Code": "Zip Code",
    // "Enter Company ZIP Code": "Enter Company ZIP Code",
    // "Location": "Location",
    // "Enter Company Location": "Enter Company Location",
    // "Billing Code": "Billing Code",
    // "Enter Company Billing Code": "Enter Company Billing Code",
    // "Employment Number": "Employment Number",
    // "Enter Company Employment Number": "Enter Company Employment Number",
    // "First Name": "First Name",
    // "Enter the First Name": "Enter the First Name",
    // "Last Name": "Last Name",
    // "Enter the Last Name": "Enter the Last Name",
    // "Enter the email": "Enter the email",
    // "Password": "Password",
    // "Enter Password": "Enter Password",
    // "Add new Customer": "Add new Customer",
    // "Customer Instance ID": "Customer Instance ID",
    // "Customer": "Customer",
    // "Organization Number": "Organization Number",
    // "GUID": "GUID",
    // "Secret Key": "Secret Key",
    // "LMS URL": "LMS URL",
    // "Stripe Connect Account": "Stripe Connect Account",
    // "Add New Customer": "Add New Customer",
    // "Important : Customer Instance ID generated automatically, is an increment of the last generated ID": "Important : Customer Instance ID generated automatically, is an increment of the last generated ID",
    // "Cancel": "Cancel",
    // "Save": "Save",
    // "Account Name": "Account Name",
    // "Sparkfore Educator": "Sparkfore Educator",
    // "Sparkfore Enterprise": "Sparkfore Enterprise",
    // "Sparkfore Team": "Sparkfore Team",
    // "Warning": "Warning",
    // "Are you sure you want to delete this account?": "Are you sure you want to delete this account?",
    // "Manage General Settings": "Manage General Settings",
    // "Create Setting": "Create Setting",
    // "Display Name": "Display Name",
    // "My Setting": "My Setting",
    // "Value": "Value",
    // "Update Setting": "Update Setting",
    // "Text": "Text",
    // "Number": "Number",
    // "Are you sure you want to delete this item?": "Are you sure you want to delete this item?",
    // "Company Email": "Company Email",
    // "Company No.": "Company No.",
    // "Phone": "Phone",
    // "Save Changes": "Save Changes",
    // "Subscription Status": "Subscription Status",
    // "Creating Subscription Failed": "Creating Subscription Failed",
    // "Customer Update Status": "Customer Update Status",
    // "Overview": "Overview",
    // "You haven’t created any forms yet. Start by clicking": "You haven’t created any forms yet. Start by clicking",
    // "Add Form": "Add Form",
    // "Logo": "Logo",
    // "Update": "Update",
    // "Do you want to delete the form?": "Do you want to delete the form?",
    // "Update Form": "Update Form",
    // "My Subscription": "My Subscription",
    // "You can choose card payment for this order": "You can choose card payment for this order",
    // "Participants": "Participants",
    // "You can choose invoice for this order": "You can choose invoice for this order",
    // "New per month": "New per month",
    // "All time": "All time",
    // "Reading Subscription Failed": "Reading Subscription Failed",
    // "This feature is not enabled in your account. Please contact support": "This feature is not enabled in your account. Please contact support",
    // "To enable the webshop, Please click the below button and onboard your Stripe Connect Account": "To enable the webshop, Please click the below button and onboard your Stripe Connect Account",
    // "Onboard Your Account": "Onboard Your Account",
    // "My generated webshop code": "My generated webshop code",
    // "My generated webshop public code" : "My generated webshop public code",
    // "Generate Code": "Generate Code",
    // "Settings": "Settings",
    // "In-Webshop": "In-Webshop",
    // "Course Title": "Course Title",
    // "Price": "Price",
    // "Shop Preview": "Shop Preview",
    // "Operation could not be completed": "Operation could not be completed",
    // "Some of the fields in the webshop are not filled properly. Please check the price and language fields and try again": "Some of the fields in the webshop are not filled properly. Please check the price and langauge fields and try again",
    // "iFrame Copied to Clipboard": "iFrame Copied to Clipboard",
    // "Page Not Found": "Page Not Found",
    // "Internal Server Error": "Internal Server Error",
    // "Access Forbidden": "Access Forbidden",
    // "Username": "Username",
    // "Login": "Login",
    // "Forgot Password?": "Forgot Password?",
    // "E-mail": "E-mail",
    // "Send Password Reset Link": "Send Password Reset Link",
    // "Back to Login": "Back to Login",
    // "Form image": "Form image",
    // "Submit": "Submit",
    // "Unfortunately This form is not available right now.": "Unfortunately This form is not available right now.",
    // "Your Email": "Your Email",
    // "Choose Password": "Choose Password",
    // "phone": "phone",
    // "Please also send me occasional emails about Sparkfore products and services": "Please also send me occasional emails about Sparkfore products and services",
    // "You can unsubscribe at any time": "You can unsubscribe at any time",
    // "Continue": "Continue",
    // "Select subdomain address": "Select subdomain address",
    // "Subdomain": "Subdomain",
    // "This domain is currently unavailable": "This domain is currently unavailable",
    // "Select payment method": "Select payment method",
    // "Card Payment": "Card Payment",
    // "Invoice Payment": "Invoice Payment",
    // "Please try again": "Please try again",
    // "Creating Subscription Success": "Creating Subscription Success",
    // "Your purchase could not be completed": "Your purchase could not be completed",
    // "We could not complete your order as the payment was not valid. For assistance, please contact Sparkfore Support at support@sparkfore.com": "We could not complete your order as the payment was not valid. For assistance, please contact Sparkfore Support at support@sparkfore.com",
    // "Contact Us": "Contact Us",
    // "Thanks for the Order": "Thanks for the Order",
    // "Thank you for your order, we have sent an order confirmation and all info to your email. Below you will find more detailed information on your order.": "Thank you for your order, we have sent an order confirmation and all info to your email. Below you will find more detailed information on your order.",
    // "Order number": "Order number",
    // "Product": "Product",
    // "Domain": "Domain",
    // "Payment period": "Payment period",
    // "Total Cost": "Total Cost",
    // "Сustomer Pages": "Сustomer Pages",
    // "Visit the Customer Pages to view details about your user details, purchases and licenses.": "Visit the Customer Pages to view details about your user details, purchases and licenses.",
    // "Open": "Open",
    // "Looks like we could not get your Subscription id": "Looks like we could not get your Subscription id",
    // "Creating Customer Instance was a failure": "Creating Customer Instance was a failure",
    // "Reading Session Failed": "Reading Session Failed",
    // "Looks like we couldn't connect to Stripe to receive your session data": "Looks like we couldn't connect to Stripe to receive your session data",
    // "Continue with Payment": "Continue with Payment",
    // "Sign In": "Sign In",
    // "This e-mail already has an account. Please try signing in and purchasing the course": "This e-mail already has an account. Please try signing in and purchasing the course",
    // "Error": "Error",
    // "Invalid Credentials": "Invalid Credentials",
    // "Account does not exist": "Account does not exist",
    // "Something Went Wrong": "Something Went Wrong",
    // "Invoice Status": "Invoice Status",
    // "Creating Invoice Failed": "Creating Invoice Failed",
    // "Payment Status": "Payment Status",
    // "Creating WebShop Payment Failed": "Creating WebShop Payment Failed",
    // "Successfully Registered! You will be redirected to the Platform in a few moment": "Successfully Registered! You will be redirected to the Platform in a few moment",
    // "Loading": "Loading",
    // "The password should contain minimum 6 characters with 1 Uppercase character, 1 Lowercase character and 1 digit with a symbol such as `-=_)(*^%$@!~": "The password should contain minimum 6 characters with 1 Uppercase character, 1 Lowercase character and 1 digit with a symbol such as `-=_)(*^%$@!~",
    // "The subdomain can contain alpha numeric characters only": "The subdomain can contain alpha numeric characters only",
    // "Censored words found in your subdomain. Please re-check and try again": "Censored words found in your subdomain. Please re-check and try again",
    // "The Subdomain is not available please try another": "The Subdomain is not available please try another",
    // "Please choose a different subdomain name. Similar available subdomain names:": "Please choose a different subdomain name. Similar available subdomain names:",
    // "Add Fields": "Add Fields",
    // "Yes": "Yes",
    // "No": "No",
    // "Upload your picture": "Upload your picture",
    // "or click here": "or click here",
    // "Start": "Start",
    // "Create New Form": "Create New Form",
    // "Copy": "Copy",
    // "Edit": "Edit",
    // "Delete": "Delete",
    // "Logout": "Logout",
    // "hour": "hour",
    // "hours": "hours",
    // "minute": "minute",
    // "minutes": "minutes",
    // "and": "and",
    // "Buy": "Buy",
    // "Go Back": "Go Back",
    // "N/A": "N/A",
    // "_COMMENT": "UPDATES ON 08:03:2022",
    // "Creating Coupon Success": "Creating Coupon Success",
    // "Creating Coupon Failed": "Creating Coupon Failed",
    // "Reading Coupon Success": "Reading Coupon Success",
    // "Reading Coupon Failed": "Reading Coupon Failed",
    // "Reading Courses Successful": "Reading Courses Successful",
    // "Reading Courses Failed": "Reading Courses Failed",
    // "Creating Customer Success": "Creating Customer Success",
    // "Creating Customer Failed": "Creating Customer Failed",
    // "Reading Customer Success": "Reading Customer Success",
    // "Reading Customer Failed": "Reading Customer Failed",
    // "Updating Customer Success": "Updating Customer Success",
    // "Updating Customer Failed": "Updating Customer Failed",
    // "Deleting Customer Success": "Deleting Customer Success",
    // "Deleting Customer Failed": "Deleting Customer Failed",
    // "Creating Customer Instance Success": "Creating Customer Instance Success",
    // "Creating Customer Instance Failed": "Creating Customer Instance Failed",
    // "Notifying Customer Instance Success": "Notifying Customer Instance Success",
    // "Notifying Customer Instance Failed": "Notifying Customer Instance Failed",
    // "Updating Customer Settings Successful": "Updating Customer Settings Successful",
    // "Updating Customer Settings Failed": "Updating Customer Settings Failed",
    // "Reading Customer Subscription Success": "Reading Customer Subscription Success",
    // "Reading Customer Subscription Failed": "Reading Customer Subscription Failed",
    // "Creating Group Success": "Creating Group Success",
    // "Creating Group Failed": "Creating Group Failed",
    // "Reading Group Failed": "Reading Group Failed",
    // "Updating Group Failed": "Updating Group Failed",
    // "Deleting Group Failed": "Deleting Group Failed",
    // "Updating Group Success": "Updating Group Success",
    // "Deleting Group Success": "Deleting Group Success",
    // "Updating User Success": "Updating User Success",
    // "Updating User Failed": "Updating User Failed",
    // "Deleting User Success": "Deleting User Success",
    // "Deleting User Failed": "Deleting User Failed",
    // "Reading Naughty List Success": "Reading Naughty List Success",
    // "Reading Naughty List Failed": "Reading Naughty List Failed",
    // "Creating WebShop Payment Success": "Creating WebShop Payment Success",
    // "Creating Checkout Session Success": "Creating Checkout Session Success",
    // "Creating Checkout Session Failed": "Creating Checkout Session Failed",
    // "Reading Checkout Session Success": "Reading Checkout Session Success",
    // "Reading Checkout Session Failed": "Reading Checkout Session Failed",
    // "Reading Product Success": "Reading Product Success",
    // "Reading Product Failed": "Reading Product Failed",
    // "Creating General Settings Item Success": "Creating General Settings Item Success",
    // "Creating General Settings Item Failed": "Creating General Settings Item Failed",
    // "Reading General Settings Success": "Reading General Settings Success",
    // "Reading General Settings Failed": "Reading General Settings Failed",
    // "Updating General Setting Item Success": "Updating General Setting Item Success",
    // "Updating General Setting Item Failed": "Updating General Setting Item Failed",
    // "Deleting General Setting Item Success": "Deleting General Setting Item Success",
    // "Payload Retrieval Success": "Payload Retrieval Success",
    // "Updating Signup Form Success": "Updating Signup Form Success",
    // "Creating Signup Form Success": "Creating Signup Form Success",
    // "Creating Signup Form Failed": "Creating Signup Form Failed",
    // "Reading Signup Form Success": "Reading Signup Form Success",
    // "Reading Signup Form Failed": "Reading Signup Form Failed",
    // "Updating Signup Form Failed": "Updating Signup Form Failed",
    // "Deleting Signup Form Successful": "Deleting Signup Form Successful",
    // "Deleting Signup Form Failed": "Deleting Signup Form Failed",
    // "Reading Stripe Active Account Successful": "Reading Stripe Active Account Successful",
    // "Reading Stripe Active Account Failed": "Reading Stripe Active Account Failed",
    // "Creating Connect Account Successful": "Creating Connect Account Successful",
    // "Creating Connect Account Failed": "Creating Connect Account Failed",
    // "Deleting Connect Account Success": "Deleting Connect Account Success",
    // "Deleting Connect Account Failed": "Deleting Connect Account Failed",
    // "Reading Connect Account Failed": "Reading Connect Account Failed",
    // "Success!": "Success!",
    // "Failed": "Failed",
    // "Error logging in user": "Error logging in user",
    // "Logging in User Failed": "Logging in User Failed",
    // "Logging in User Success": "Logging in User Success",
    // "Logging out User Error": "Logging out User Error",
    // "Creating User Success": "Creating User Success",
    // "Creating User Failed": "Creating User Failed",
    // "Reading Users Successful": "Reading Users Successful",
    // "Reading Users Failed": "Reading Users Failed",
    // "Updating Users Failed": "Updating Users Failed",
    // "Deleting Users Failed": "Deleting Users Failed",
    // "Creating WebShop Success": "Creating WebShop Success",
    // "Creating WebShop Failed": "Creating WebShop Failed",
    // "Reading WebShop Failed": "Reading WebShop Failed",
    // "Updating WebShop Failed": "Updating WebShop Failed",
    // "Deleting WebShop Failed": "Deleting WebShop Failed",
    // "Reading WebShop Items Success": "Reading WebShop Items Success",
    // "Reading WebShop Items Failed": "Reading WebShop Items Failed",
    // "Updating Webshop Successful": "Updating Webshop Successful",
    // "Updating WebShop Items Failed": "Updating WebShop Items Failed",
    // "Reading Course Success": "Reading Course Success",
    // "Enrolling User Success": "Enrolling User Success",
    // "Creating Charge Success": "Creating Charge Success",
    // "Creating Charge Failed": "Creating Charge Failed",
    // "Updating Webshop Payment Success": "Updating Webshop Payment Success",
    // "Updating Webshop Payment Failed": "Updating Webshop Payment Failed",
    // "Registering User Failed": "Registering User Failed",
    // "Updating User Registration Count Failed": "Updating User Registration Count Failed",
    // "Logging In User Failed": "Logging In User Failed",
    // "Enrolling User Failed": "Enrolling User Failed",
    // "": "",
    // "_COMMENT_2": "UPDATES ON 22:03:2022",
    // "Order Certificate":"Order Certificate",
    // "I want to order a certificate": "I want to order a certificate"
    //    }
    //        var hhh = "{";
    //       for (const [key, value] of Object.entries(ddd)) {
    //         console.log(`${key}: ${value}`);
    //         // hhh += '"' + key + '": "' + key + '",';
    //           hhh += '"' + key + '": "",';
    //       }
    //        hhh += "}";
    //        console.log(hhh);
    this.$store.dispatch("getAllSettings").then((result) => {
      i18n.locale = Common.determineUserLang(result, Object.keys(i18n.messages));
    });
  },
  async created() {
    await this.$store.dispatch("retrieveUser");
  },
  computed: {
    isPublicRoute() {
      const publicRoutes = this.$store.getters.allPublicRoutes;
      return publicRoutes.includes(this.$route.name);
    },
    isMPRoute() {
      const routes = this.$store.getters.allNoMPPublicRoutes;
      return !routes.includes(this.$route.name);
    },
    LangConstants() {
      return Constants;
    },
  },
  methods: {
    // addEmbedUrl() {
    //   let content;
    //   const authUser = this.$store.getters.getAuthUser;
    //   const instnace_id = authUser.instance_id;
    //   const url = this.$store.getters.spInstanceVueURL + "company-account/web-shop/public/" + instnace_id;
    //   content = `<iframe frameborder="0" scrolling="yes" seamless="seamless" style="display:block; width:100%;" id="pJCFusFJJ02cp7v4uwtfA" src="` + url + `" title="Webshop"></iframe>`;
    //   content += `<script> const X65fxOVTkeBQYiemvZZxA=window.addEventListener?"addEventListener":"attachEvent",ZFlYUbR37kqkxO5T0MmuIw=window[X65fxOVTkeBQYiemvZZxA],a0BiRNbzwUOfmpTiWIMRQ="attachEvent"==X65fxOVTkeBQYiemvZZxA?"onmessage":"message";ZFlYUbR37kqkxO5T0MmuIw(a0BiRNbzwUOfmpTiWIMRQ,e=>{isNaN(e.data)||(document.getElementById("pJCFusFJJ02cp7v4uwtfA").style.height=e.data+"px")},!1);</scr` + `ipt>`;
    //   this.$refs.formUrl.selectedValue = content;
    //   this.embedLink = content;
    // },
    getAuthUser() {
      return Common.getFromLocalStorage(Constants.auth_user, true);
    },
  },
  components: {
    MyHeader,
    //Sidebar,
  },
  mounted() {
    this.$root.$on("header:ToggleSidebar", () => {
      this.isClosed = !this.isClosed;
    });
  },
};
</script>
<style lang="scss">
.b-overlay-wrap {
  .position-absolute {
    // position: fixed !important;
  }
}
</style>
